import {
  Loader,
  MantineThemeOverride,
  NumberInput,
  PasswordInput,
  Table,
} from '@mantine/core';

const theme: MantineThemeOverride = {
  fontFamily: 'Plus Jakarta Sans',
  headings: { fontFamily: 'Plus Jakarta Sans' },

  colors: {
    brand: [
      '#6fa1f6',
      '#4885f5',
      '#3473f5',
      '#2a6bf7',
      '#205adc',
      '#1650c5',
      '#0044ad',
      '#003e96',
      '#003880',
      '#00326b',
    ],
  },

  primaryColor: 'brand',

  defaultRadius: 'lg',

  cursorType: 'pointer',

  components: {
    Loader: Loader.extend({
      defaultProps: {
        variant: 'bars',
      },
    }),
    PasswordInput: PasswordInput.extend({
      styles: {
        innerInput: {
          border: 'none',
        },
      },
    }),
    NumberInput: NumberInput.extend({
      styles: {
        input: {
          border: 'calc(.0625rem* var(--mantine-scale)) solid var(--input-bd)',
          borderRadius: 'var(--input-radius)',
        },
      },
    }),
    Table: Table.extend({
      styles: {
        td: {
          paddingLeft: '0',
          paddingRight: '0',
        },
      },
    }),
  },
};

export default theme;
